var _rect, _rect2, _rect3, _rect4, _rect5;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFlagCa(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 9 9",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 9,
    height: 9,
    fill: "#FCDD09"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 1,
    width: 9,
    height: 1,
    fill: "#DA121A"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 3,
    width: 9,
    height: 1,
    fill: "#DA121A"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    y: 5,
    width: 9,
    height: 1,
    fill: "#DA121A"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    y: 7,
    width: 9,
    height: 1,
    fill: "#DA121A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagCa);
export default __webpack_public_path__ + "static/media/flag-ca.6994b129e04ee96fa3ab7a17d40d2654.svg";
export { ForwardRef as ReactComponent };